import React from 'react';
import { Helmet } from 'react-helmet-async';
import { APP_NAME, APP_DESCRIPTION } from '../constants';

const MetaTags: React.FC = () => {
  return (
    <Helmet>
      <title>{APP_NAME}</title>
      <meta name="description" content={APP_DESCRIPTION} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={APP_NAME} />
      <meta property="og:description" content={APP_DESCRIPTION} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary" />
      <meta property="twitter:title" content={APP_NAME} />
      <meta property="twitter:description" content={APP_DESCRIPTION} />
    </Helmet>
  );
};

export default MetaTags;
